import {
  ApplicationRef,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  inject,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';

import _ from 'lodash';
import { Subject } from 'rxjs';

@Injectable()
export class ModalService {
  private appRef = inject(ApplicationRef);

  factoryResolver: ComponentFactoryResolver;
  rootViewContainer: unknown;

  constructor() {
    const factoryResolver = inject<ComponentFactoryResolver>(ComponentFactoryResolver);

    this.factoryResolver = factoryResolver;
  }

  setRootViewContainerRef(viewContainerRef: unknown) {
    this.rootViewContainer = viewContainerRef;
  }

  create<T>(config: SpaModalConfig): SpaModal<T> {
    const { comp, data } = config;

    const subject = new Subject<T | undefined>();

    const closeDialog = (res?: T) => {
      this.appRef.detachView(componentRef.hostView);
      componentRef.destroy();
      subject.next(res);
    };

    const modal: SpaModal<T> = {
      close: closeDialog,
      onClose: subject,
    };

    const componentFactory = this.factoryResolver.resolveComponentFactory(comp);

    const injector: Injector = Injector.create([{ provide: SPA_DIALOG, useValue: modal }]);

    const componentRef = componentFactory.create(injector);

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>).rootNodes[0] as HTMLElement;

    document.body.appendChild(domElem);

    _.forOwn(data, (v, k) => {
      componentRef.setInput(k, v);
    });

    return modal;
  }
}

export const SPA_DIALOG = new InjectionToken<string>('SPA_DIALOG');

export interface SpaModalConfig {
  comp: Type<unknown>;
  data?: unknown;
}

export interface SpaModal<T> {
  onClose: Subject<T | undefined>;
  close: (res?: T) => void;
}
